const GA4_ID = process.env.REACT_APP_GA4_ID;
const GTM_ID = process.env.REACT_APP_GTM_ID;
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const CONSENT_KEY = "contabeleza_cookie_consent";

export const getConsent = () => {
    try {
        return localStorage.getItem(CONSENT_KEY);
    } catch {
        return null;
    }
};

export const setConsent = (value) => {
    try {
        localStorage.setItem(CONSENT_KEY, value);
    } catch {
        /* storage unavailable */
    }
    if (value === "accepted") initAnalytics();
};

function injectGTM() {
    if (!GTM_ID || document.getElementById("gtm-script")) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
    const s = document.createElement("script");
    s.id = "gtm-script";
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(s);
}

function injectGA4() {
    if (!GA4_ID || GTM_ID || document.getElementById("ga4-script")) return;
    const s = document.createElement("script");
    s.id = "ga4-script";
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
        window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID, { send_page_view: false });
}

function injectPixel() {
    if (!PIXEL_ID || window.fbq) return;
    const n = (window.fbq = function fbq() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    const s = document.createElement("script");
    s.async = true;
    s.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(s);
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
}

export function initAnalytics() {
    if (getConsent() !== "accepted") return;
    injectGTM();
    injectGA4();
    injectPixel();
}

export function trackEvent(name, params = {}) {
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name, ...params });
        if (window.gtag) window.gtag("event", name, params);
        if (window.fbq) window.fbq("trackCustom", name, params);
    } catch {
        /* tracking is best-effort */
    }
}

export function trackPageView(path) {
    trackEvent("page_view", { page_path: path, page_title: document.title });
}

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid"];

export function captureUtmParams() {
    try {
        const query = new URLSearchParams(window.location.search);
        const stored = JSON.parse(sessionStorage.getItem("cbz_utm") || "{}");
        UTM_KEYS.forEach((key) => {
            const value = query.get(key);
            if (value) stored[key] = value;
        });
        sessionStorage.setItem("cbz_utm", JSON.stringify(stored));
    } catch {
        /* ignore */
    }
}

export function getStoredUtm() {
    try {
        return JSON.parse(sessionStorage.getItem("cbz_utm") || "{}");
    } catch {
        return {};
    }
}
